// angular
//     .module("HeroPRO")
//     .controller("EsignDocumentsController", eSignDocumentsController);

import _ from 'lodash';

/* @ngInject */
export default function eSignDocumentsController($scope, HPStateMachineConfig, FRInformationFactory, FRDocumentsFactory, $stateParams, DocumentLink) {
    const vm = this;
    vm.showGetSignaturesButton = false;
    vm.CCDocument = null;
    vm.ACADocument = null;
    vm.HPStateMachineConfig = HPStateMachineConfig;
    vm.stateMachineData = {};

    init();

    /*= =======================================
     =            Public Functions            =
     ======================================== */
    vm.completionCertificateLink = () => DocumentLink.getCompletionCertificateLinkFunding($stateParams.appId, vm.CCDocument);

    vm.getACALink = () => DocumentLink.getFinancialDocumentsLink(FRDocumentsFactory.getACADocument());

    vm.getUploadButtonText = () => {
        if (vm.CCDocument.status.CCUploaded === true) {
            return 'Replace';
        }
        return 'Upload';
    };
    /* -----  End of Public Functions  ------*/


    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(() => {
            vm.stateMachineData = FRInformationFactory.getStateMachineData();
        });

        FRDocumentsFactory.getFundingRequestDocumentsPromise().then(() => {
            vm.showGetSignaturesButton = FRDocumentsFactory.getSignaturesButtonVisibility();
            vm.CCDocument = FRDocumentsFactory.getCCDocument();
            vm.ACADocument = FRDocumentsFactory.getACADocument();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/documents/esignDocumentsController.js